module.exports = __webpack_public_path__ + "img/event2025_0318.fcc5b212.jpg";